export enum SPropTypeEnum{
    SOBJECT = 'object',
    SARRAY = 'array',
    SSTRING = 'string',
    SNUMBER = 'number',
    SBOOLEAN = 'checkbox',
    SNULL = 'null'
}
